import { createSlice } from '@reduxjs/toolkit';
import { NotificationEntity, RelationEntity } from '@interpals/api-web';

import { updateRelation } from 'redux/profile/actions';
import { logout } from 'redux/auth/actions';

import { getNotifications, getFriendRequests, setNotificationsLastFetched, markNotificationsRead } from './actions';

export interface NotificationsState {
    notifications: {
        data: NotificationEntity[];
        loading: boolean;
        hasMore: boolean;
    };
    friendRequests: RelationEntity[];
    lastFetchTimestamp?: number;
}

const initialState: NotificationsState = {
    notifications: {
        data: [],
        loading: false,
        hasMore: true,
    },
    friendRequests: [],
};

const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getNotifications.pending, (state) => {
            state.notifications.loading = true;
        });

        builder.addCase(getNotifications.fulfilled, (state: NotificationsState, { payload }) => {
            state.notifications.loading = false;
            state.notifications.data = [...state.notifications.data, ...payload.data];
            state.notifications.hasMore = payload.hasMore;
        });

        builder.addCase(getNotifications.rejected, (state: NotificationsState) => {
            state.notifications.loading = false;
        });

        builder.addCase(markNotificationsRead.fulfilled, (state) => {
            state.notifications.data = state.notifications.data.map((notification) =>
                Object.assign(notification, (notification.uread = false)),
            );
        });

        builder.addCase(getFriendRequests.fulfilled, (state, { payload }) => {
            state.friendRequests = payload.data;
        });

        builder.addCase(updateRelation.fulfilled, (state, { payload }) => {
            state.friendRequests = state.friendRequests.filter((requests) => requests.target_id !== payload.target_id);
        });

        builder.addCase(logout.fulfilled, () => {
            return initialState;
        });

        builder.addCase(setNotificationsLastFetched, (state, { payload: lastFetched }) => {
            state.lastFetchTimestamp = lastFetched;
        });
    },
});

export default notificationsSlice.reducer;
